define(['text!./templates/custom-quote.html',
        'edge/quoteandbind/common/app'
    ],
    (templateStr)=> {
        return ['$window', '$timeout', function ($window, $timeout) {
            return {
                restrict: 'A',
                template: templateStr,
                require: 'gwQnbCustomQuote',
                scope: {
                    standardOffering: '=',
                    customQuote: '=',
                    buy: '=',
                    sessionid: '=',
                    submissionid: '=',
                    header:'@',
                    biLimits:'@',
                    lob: '@',
                    nextSteps: '&'
                },
                controller: ['$scope', 'qnb.CustomQuoteService', '$q', '$filter', 'ModalService', 'ViewModelService', '$state' ,
                    function ($scope, CustomQuoteService, $q, $filter, ModalService, ViewModelService, $state) {
                        const self = this;


                        $scope.view = ViewModelService.create($scope.customQuote, 'pc', 'edge.capabilities.quote.quoting.dto.QuoteDTO');

                        const jobNumber = $scope.view.quoteID.value;

                        $scope.syncCoverage = ()=> {
                            $scope.quoteStatus.isStale = true;
                            if (!self._validateInputFields()) {
                                return;
                            }

                            $scope.quoteStatus.showLoading = true;
                            $scope.quoteStatus.calculatingQuote = true;
                            const operation = CustomQuoteService.updateCustomQuoteCoverages('quoteandbind', $scope.customQuote, $scope.sessionid, $scope.submissionid);
                            operation.then((quote)=> {
                                $scope.customQuote.lobs = quote.lobs;
                            });
                            operation.catch(self._handleQuoteError);
                            operation.finally(()=> {
                            $timeout(function(){
                                  $scope.quoteStatus.showLoading = false;
                                  $scope.quoteStatus.calculatingQuote = false;
                                  $scope.CustomQuoteForm.submitted = false;
                             }, 3000);

                            });
                        };

                        $scope.markStale = ()=> {
                            $scope.quoteStatus.isStale = true;
                        };

                        $scope.buyQuote = function () {
                            if (!self._validateInputFields()) {
                                return;
                            }
                            $scope.buy.apply(null, arguments);
                        };

                        $scope.buyQuoteWithDefaultParams = ()=> {
                            const termInMonths = $scope.customQuote.termMonths;
                            $scope.buy($scope.customQuote, termInMonths);
                        };


                        this.updateQuote = ()=> {
                            if (!$scope.quoteStatus.isStale || !$scope.customQuote.total || !self._validateInputFields()) {
                                //disable action if coverage selections have not changed or we don't have an existing quote price
                                return;
                            }

                            $scope.quoteStatus.calculatingQuote = true;
                            $scope.quoteStatus.showLoading = true;

                            const operation = CustomQuoteService.updateCustomQuote('quoteandbind', $scope.customQuote, $scope.sessionid, $scope.submissionid);
                            operation.then((updatedCustomQuote)=> {
                                $scope.customQuote.lobs = updatedCustomQuote.lobs;
                                $scope.customQuote.total = updatedCustomQuote.total;
                                $scope.customQuote.monthlyPremium = updatedCustomQuote.monthlyPremium;
                                $scope.customQuote.totalBeforeTaxes = updatedCustomQuote.totalBeforeTaxes;
                                $scope.customQuote.taxes = updatedCustomQuote.taxes;
                                $scope.quoteStatus.isStale = false;
                            });
                            operation.catch(self._handleQuoteError);
                            operation.finally(()=> {
                                $scope.quoteStatus.calculatingQuote = false;
                                $scope.quoteStatus.showLoading = false;
                                $scope.CustomQuoteForm.submitted = false;
                            });
                        };

                        function removeDuplicates(msg,text){
                             var msgArray = msg.split(text);
                             if(msgArray.length === 1)
                                return msg;
                             const unique = [...new Set(msgArray)];
                             var modifiedMsg = '';
                             for(var count = 0;count < unique.length;count++){
                               if(unique[count].trim() !== ''){
                                    modifiedMsg =  modifiedMsg + text + unique[count];
                                }
                             }
                             return modifiedMsg;

                            }


                        this._handleQuoteError = (error)=> {
                            const message = $filter('translate')('integration.quoteandbind.directives.custom-quote.Invalid Coverage Option');
                            var description = $filter('translate')('integration.quoteandbind.directives.custom-quote.Sorry, but that coverage option is invalid, please select a different value');
                            var errorMsg = description;
                            if(error.constructor != Array && error.baseError.data.error.message != undefined && error.baseError.data.error.message.constructor != Array){
                                errorMsg = error.baseError.data.error.message;
                                                                if(errorMsg.indexOf('Dwelling_HOE')> -1) {
                                                                    if(errorMsg.indexOf('warning')> -1){
                                                                      errorMsg = errorMsg.replace(/warning:entity.Dwelling_HOE\//g, '<br>&#9679;&nbsp;');
                                                                    }
                                                                    if(errorMsg.indexOf('error')> -1){
                                                                      errorMsg = errorMsg.replace(/error:entity.Dwelling_HOE\//g, '<br>&#9679;&nbsp;');
                                                                    }
                                                                    errorMsg = errorMsg.replace(/;/g, '');
                                                                }
                                                                if(errorMsg.indexOf('HomeownersLine_HOE')> -1) {
                                                                   if(errorMsg.indexOf('warning')> -1){
                                                                     errorMsg = errorMsg.replace(/warning:entity.HomeownersLine_HOE\//g, '<br>&#9679;&nbsp;');
                                                                   }
                                                                   if(errorMsg.indexOf('error')> -1){
                                                                     errorMsg = errorMsg.replace(/error:entity.HomeownersLine_HOE\//g, '<br>&#9679;&nbsp;');
                                                                   }
                                                                   errorMsg = errorMsg.replace(/;/g, '');
                                                                }
                                                                if(errorMsg.indexOf('PersonalAutoLine')> -1) {
                                                                   if(errorMsg.indexOf('warning')> -1){
                                                                    errorMsg = errorMsg.replace(/warning:entity.PersonalAutoLine\//g, '<br>&#9679;&nbsp;');
                                                                   }
                                                                   if(errorMsg.indexOf('error')> -1){
                                                                    errorMsg = errorMsg.replace(/error:entity.PersonalAutoLine\//g, '<br>&#9679;&nbsp;');
                                                                   }
                                                                    errorMsg = errorMsg.replace(/;/g, '');
                                                                }
                                                                if(errorMsg.indexOf('PersonalVehicleCov')> -1) {
                                                                    if(errorMsg.indexOf('warning')> -1){
                                                                     errorMsg = errorMsg.replace(/warning:entity.PersonalVehicleCov\//g, '<br>&#9679;&nbsp;');
                                                                    }
                                                                    if(errorMsg.indexOf('error')> -1){
                                                                     errorMsg = errorMsg.replace(/error:entity.PersonalVehicleCov\//g, '<br>&#9679;&nbsp;');
                                                                    }
                                                                    errorMsg = errorMsg.replace(/;/g, '');
                                                                }
                                                                if(errorMsg.indexOf('PersonalVehicle')> -1) {
                                                                    if(errorMsg.indexOf('warning')> -1){
                                                                       errorMsg = errorMsg.replace(/warning:entity.PersonalVehicle\//g, '<br>&#9679;&nbsp;');
                                                                    }
                                                                    if(errorMsg.indexOf('error')> -1){
                                                                       errorMsg = errorMsg.replace(/error:entity.PersonalVehicle\//g, '<br>&#9679;&nbsp;');
                                                                    }
                                                                    errorMsg = errorMsg.replace(/;/g, '');
                                                                }
                                                                if(errorMsg.indexOf('PersonalAutoCov')> -1) {
                                                                    if(errorMsg.indexOf('warning')> -1){
                                                                       errorMsg = errorMsg.replace(/warning:entity.PersonalAutoCov\//g, '<br>&#9679;&nbsp;');
                                                                    }
                                                                    if(errorMsg.indexOf('error')> -1){
                                                                       errorMsg = errorMsg.replace(/error:entity.PersonalAutoCov\//g, '<br>&#9679;&nbsp;');
                                                                    }
                                                                    errorMsg = errorMsg.replace(/;/g, '');
                                                                }
                                                                if(errorMsg.indexOf('HomeownersCovCost_HOE')> -1) {
                                                                    if(errorMsg.indexOf('warning')> -1){
                                                                      errorMsg = errorMsg.replace(/warning:entity.HomeownersCovCost_HOE\//g, '<br>&#9679;&nbsp;');
                                                                    }
                                                                    if(errorMsg.indexOf('error')> -1){
                                                                      errorMsg = errorMsg.replace(/error:entity.HomeownersCovCost_HOE\//g, '<br>&#9679;&nbsp;');
                                                                    }
                                                                    errorMsg = errorMsg.replace(/;/g, '');
                                                                }
                                                                if(errorMsg.indexOf('PolicyPeriod')> -1) {
                                                                    if(errorMsg.indexOf('warning')> -1){
                                                                        errorMsg = errorMsg.replace(/warning:entity.PolicyPeriod\//g, '<br>&#9679;&nbsp;');
                                                                    }
                                                                    if(errorMsg.indexOf('error')> -1){
                                                                        errorMsg = errorMsg.replace(/error:entity.PolicyPeriod\//g, '<br>&#9679;&nbsp;');
                                                                    }
                                                                    errorMsg = errorMsg.replace(/;/g, '');
                                                                }
                                                                if (errorMsg.indexOf('DisplayableException') > -1) {
                                                                errorMsg = errorMsg.replace(/gw.api.util.DisplayableException:/g, '<br>&#9679;&nbsp;');
                                                                }
                            }
                            errorMsg = removeDuplicates(errorMsg,'<br>&#9679&nbsp');
                            console.log(errorMsg);
                            if (errorMsg.indexOf('out of state exposure') > 0) {
                                $state.go('contactUs', {quoteID: jobNumber});
                            } else {
                                ModalService.showError(message, errorMsg);
                            }

                           // ModalService.showError(message, description);
                            //console.log('Error updating custom quote', error);
                        };

                        /**
                         * Checks that there are no invalid inputs or nested forms, displays a modal prompting the user to
                         * fix errors.
                         *
                         * @returns {boolean}
                         */
                        this._validateInputFields = ()=> {
                            if (!$scope.view.aspects.subtreeValid) {
                                const message = $filter('translate')('integration.quoteandbind.directives.custom-quote.Invalid input values');
                                const description = $filter('translate')('integration.quoteandbind.directives.custom-quote.Please correct input field errors');
                                //ModalService.showError(message, description);
                                //$scope.CustomQuoteForm.submitted = true;
                                //return false;
                            }
                            //If the form is valid then reset the submitted value. So pristine fields are not marked with errors
                            $scope.CustomQuoteForm.submitted = false;
                            return true;
                        };

                        $scope.quoteStatus = {
                            calculatingQuote: false,
                            showLoading: false,
                            displayed: false,
                            isStale: false
                        };

                        $scope.$on('CustomQuoteSelected', ()=> {
                            //have to wait until custom tab is selected and tab contents are visible
                            $timeout(()=> {
                                $scope.quoteStatus.displayed = true;
                            }, 50);
                        });

                        $scope.updateQuote = this.updateQuote;
                    }],
                'link': (scope, elt)=> {
                    elt[0].addEventListener('change', ()=> {
                        scope.quoteStatus.isStale = true;
                    });
                }
            };
        }];
    }
);



/** WEBPACK FOOTER **
 ** ./common/js/src/integration/quoteandbind/directives/CustomQuote.js
 **/